<template>
  <anchor-modal :anchorText="anchorText">
    <aside class="+mg-md +text-size-xs">
      <article>
        <h2 class="heading-secondary +heading-epsilon +mg-bottom-sm">
          Advertiser Disclosure
        </h2>
        <p>
          We are an independent, advertising-supported comparison service. Our
          goal is to help you make smarter financial decisions by providing you
          with interactive tools and financial calculators, publishing original
          and objective content, by enabling you to conduct research and compare
          information for free - so that you can make financial decisions with
          confidence.<br />
          Bankrate has partnerships with issuers including, but not limited to,
          American Express, Bank of America, Capital One, Chase, Citi and
          Discover.
        </p>
      </article>
      <article>
        <h2 class="heading-secondary +heading-epsilon +mg-bottom-sm">
          How We Make Money.
        </h2>
        <p>
          The offers that appear on this site are from companies that compensate
          us. This compensation may impact how and where products appear on this
          site, including, for example, the order in which they may appear
          within the listing categories. But this compensation does not
          influence the information we publish, or the reviews that you see on
          this site. We do not include the universe of companies or financial
          offers that may be available to you.
        </p>
      </article>
    </aside>
  </anchor-modal>
</template>

<script>
import AnchorModal from '../../anchor-modal/anchor-modal.vue'

export default {
  data() {
    return {
      anchorText: 'Advertiser Disclosure'
    }
  },
  components: {
    AnchorModal
  }
}
</script>
